import { render, staticRenderFns } from "./QuillInput.vue?vue&type=template&id=87383aa6"
import script from "./QuillInput.vue?vue&type=script&lang=js"
export * from "./QuillInput.vue?vue&type=script&lang=js"
import style0 from "./QuillInput.vue?vue&type=style&index=0&id=87383aa6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports